export const getTOFProgramManagement = `query GetTOFProgramsManagement($filter: TOFProgramManagementRequest!) {
  tofProgramsManagement(filter: $filter) {
    tofManagement {
      pkId
      version
      region
      productFamily
      productGroup
      parameterKey
      parameterValue
      parameterText
      comments
      status
      createdBy
      whoChanged
      lastModifiedDate
    }
  }
}`;